
(function(template){
define('vue!modeSelector/components/GroupMemberListComponent',['Vue','vuex','helpers','underscore'],function(Vue,vuex,helpers,_){
    return {
        name: 'Group-Member-List',
        template: template,
        props: ['fromApp','showPopup'],
        data: function(){
            return {
                groupMembers: [],
                selected: false,
                selectedGroupMembers:[],
                newGroupMembers: [{FirstName: '', LastName: ''}]
            }
        },
        computed:  _.extend(vuex.mapState(['desktopMode','users','usersWithIds']),{
            customerName: function(){
                return app.data.FirstName + ' ' + app.data.LastName
            },
            disableSaveButton: function(){
                var nonNullNewGroupMembers = this.newGroupMembers.filter(function(gm){ return gm.FirstName.concat(gm.LastName).length > 0 });
                return this.selectedGroupMembers.concat(nonNullNewGroupMembers).length == 0 || nonNullNewGroupMembers.length == 0;
            }
        }),
        methods: _.extend( vuex.mapMutations(['addGroupMember','addUserWithId']),
        {
            handleSaveKeyDown: function(e) {
                e.target.click()
            },
            handleKeyDown: function(e, index){
                var vm = this;
                this.a11yKeyDown(e, {
                    down: function() {
                        e.preventDefault();
                        if(index == vm.groupMembers.length-1) return;
                        $('.groupMemberList .groupMember')[index+1].focus();
                    },
                    up: function() {
                        e.preventDefault();
                        if(index == 0) return;
                        $('.groupMemberList .groupMember')[index-1].focus();
                    },
                    shiftTab: function() {
                        if(!vm.fromApp) return;
                        e.preventDefault();
                        $('.content-spaPackageTpl #app #vue-cart .componentHeader .component-popup i').focus();
                    },
                    tab: function() {
                        e.preventDefault();
                        $('.addGuest .addGuestFields input')[0].focus();
                    },
                    enter: function() {
                        $('.groupMemberList .groupMember label')[index].click();
                        $('.groupMemberList .groupMember')[index].focus();
                    }
                })
            },
            handleCheckBoxClick : function(e,userId){
                if(e.target.checked) {

                //recent fix for the age restriction logic. There always a single user to begin with. And my age restriction check automatically runs moment the user clicks on the service. If the user didn't meet the age requirement, my schedule btn is disabled. When there is more than 1 user, then the guest has to click on the checkbox to run select it. The issue that was happening is at this point if you add another user which meets the age requirement, btn would still be disabled because previously it ran for the first user automatically and that has to be removed
                if(_.keys(this.users).length == 1 && _.isEmpty(this.users[_.keys(this.users)[0]])){
                    this.$store.commit('setScheduleBtnValidity', {
                            action: "remove",
                            removeAll: true
                    })
                }
                    this.$store.commit('addUser',{userId:userId});
                    return;
                }
                if(_.isEmpty(this.users[userId] || {})) { //if user doesnot have any thing scheduled, allow remove
                    this.$store.commit('removeGuestMember',{userId:userId});
                    return;
                }

                if(!(_.isEmpty(this.users[userId] || {}))) {

                      if(this.desktopMode){
                          this.$store.commit('addGlobalMessage',{type: 'error',message:this.usersWithIds[userId]+' '+  this.localStrings.errors.customerHasBookings});
                         $('.messages-container')[0].scrollIntoView({block:'center',behavior: "smooth"});
                        }
                    else{
                        this.$store.commit('SetmobileViewMessages',{key: 'fail',message:this.usersWithIds[userId]+' '+  this.localStrings.errors.customerHasBookings})
                         window.scrollTo({top: 0,left: 0,behavior: 'smooth'})
                    }
                }

                e.preventDefault(); // prevent remove
            },
            handleClick : function(){
                if (!app.data.store) app.datal('store', {});
                if (!app.data.store.WebFolioId || app.data.store.WebFolioId != app.data.WebFolioId) app.datal('store', {
                    WebFolioId: app.data.WebFolioId,
                });
                app.datal('store', _.extend(app.data.store, {
                    groupMembersSelected: true
                }));
                if(this.disableSaveButton) {
                    if(this.desktopMode){
                        this.$store.commit('addGlobalMessage',{type: 'warn',message: this.localStrings.errors.noGuestSelected});
                            $('.messages-container')[0].scrollIntoView({block:'center',behavior: "smooth"});
                        }
                    else{
                          this.$store.commit('SetmobileViewMessages',{key: 'fail',message: this.localStrings.errors.noGuestSelected})
                         window.scrollTo({top: 0,left: 0,behavior: 'smooth'})
                    }
                return;
                };
                this.resolveInSeries(this.newGroupMembers,0, this);
            },
            resolveInSeries: function(arr,index, vm ){
                if(index==arr.length){
                    this.newGroupMembers = [{FirstName: '', LastName: ''}];
                    if(this.fromApp) this.$emit('update:showPopup',false);
                    else this.goNext();
                    return;
                };
                var member = arr[index];
                if(member.FirstName.concat(member.LastName).replace(/\s/g,'').length==0){
                    this.resolveInSeries(arr,index+1, vm);
                    return;
                };
                helpers.addGroupMember(member.FirstName,member.LastName).then(function(res) {
                    vm.groupMembers.push({name: member.FirstName+' '+member.LastName, id: res.newUserId});
                    vm.selectedGroupMembers.push(res.newUserId);
                    vm.resolveInSeries(arr,index+1, vm);
                }).fail(function(err){
                    alert(err);
                });
            }
        }),
        mounted: function(){
            var vm = this;
            vm.groupMembers.push({ name:this.customerName, id:app.data.CustomerId })
            helpers.fetchGroupMembers().then(function(groupMembers){
               // console.log('ii-i',groupMembers);
                groupMembers.GroupMember.forEach(function (member) {
                    var name = member.Name.FirstName + " " + member.Name.LastName;
                    if(_.findIndex(vm.groupMembers, function(item){ return item.id == member.CustomerId })){
                        vm.groupMembers.push({id:member.CustomerId, name:name});
                        vm.addGroupMember(name);
				        vm.addUserWithId({name: name, id: member.CustomerId});
                    }
                });
                vm.selectedGroupMembers = _.keys(vm.users);
            });

        },
        watch: {
            newGroupMembers: {
                handler: function(arr) {
                    var name = arr[arr.length-1];
                    if(name.FirstName.concat(name.LastName).replace(/\s/g,'').length>0){
                        this.newGroupMembers.push({FirstName: '', LastName: ''});
                    }
                },
                deep: true
            },
            users: function(val){
                var userIdsInStore = _.keys(val);
                this.selectedGroupMembers = this.selectedGroupMembers.filter(function(userId){
                    return userIdsInStore.indexOf(userId) > -1;
                })
            }
        }
    }
})
})('<div> <div v-if="!fromApp"> <p><b>{{localization.spaBooking.packageBooking.modeSelector.welcomeBackText}} {{customerName}}!</b></p> <p><b>{{localization.spaBooking.packageBooking.modeSelector.whoscomingText}}</b></p> </div> <div role="form" aria-label="Group member" class="groupMemberList"> <div class="groupMember" tabindex="0" @keydown="handleKeyDown($event,index)" v-for="(member,index) in groupMembers" :key="index"> <label><input type="checkbox" @click="handleCheckBoxClick($event,member.id)" :value="member.id" v-model="selectedGroupMembers" tabindex="-1"> {{member.name}}</label> </div> </div> <div role="form" aria-label="Guest Information" class="addGuest"> <p>{{localization.spaBooking.packageBooking.modeSelector.newGuestText}}</p> <div class="addGuestFields" v-for="(guest,index) in newGroupMembers" :key="index"> <input type="text" class="customTextInput" placeholder="First Name" aria-label="Guest first name" v-model="guest.FirstName" /> <input type="text" class="customTextInput" placeholder="Last Name" aria-label="Guest last name" v-model="guest.LastName" /> </div> </div> <button class="btn customBlueButton" :disabled="disableSaveButton" @click="handleClick">{{fromApp ? localization.spaBooking.packageBooking.modeSelector.saveButonText : localization.spaBooking.packageBooking.modeSelector.doneButonText}}</button> </div>');
